jQuery($ => {

  if($('.o-instagram-feed')[0]){
    $('.m-feed-posts__list').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: true,
            infinite: true,

          },
        },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: true,
              infinite: true,

            },
        },
      ]
    });
  }

});